// src/pages/TermsConditions.js
import React from 'react';

export default function TermsConditions({ go }) {
  return (
    <div className="page-container" style={{ maxWidth: '1180px', margin: '0 auto', padding: '0 28px' }}>
      <div style={{ padding: '64px 0 40px', borderBottom: '1px solid #E3DACB' }}>
        <span style={{ 
          fontSize: '12.5px', 
          fontWeight: '700', 
          letterSpacing: '0.14em', 
          textTransform: 'uppercase',
          color: '#C96F22',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <span style={{ width: '18px', height: '2px', background: '#C96F22', display: 'inline-block' }}></span>
          Legal
        </span>
        <h1 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: 'clamp(32px, 4vw, 46px)',
          color: '#102844',
          marginTop: '14px'
        }}>Terms & Conditions</h1>
        <p style={{ marginTop: '14px', color: '#5B6469', fontSize: '14.5px' }}>
          Last updated: June 19, 2026 &nbsp;·&nbsp; Applies to the YojanaSaathi mobile app and website
        </p>
      </div>

      <div style={{ padding: '56px 0 96px' }}>
        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Acceptance of terms</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          These Terms & Conditions ("Terms") govern your use of the YojanaSaathi mobile app and website (together, the "Service"), operated by YojanaSaathi. By creating an account or using the Service, you agree to be bound by these Terms.
        </p>

        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Description of service</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          YojanaSaathi helps citizens and businesses identify government schemes they may be eligible for, based on details they provide, and allows them to submit applications for those schemes through the app where supported.
        </p>

        <div style={{
          background: '#FFFFFF',
          border: '1px solid #E3DACB',
          borderLeft: '4px solid #C96F22',
          borderRadius: '10px',
          padding: '18px 20px',
          margin: '20px 0'
        }}>
          <p style={{ margin: 0, fontSize: '14.5px', color: '#5B6469' }}>
            <strong>Important:</strong> YojanaSaathi is an independent platform and is not affiliated with, endorsed by, or operated by the Government of India or any state government.
          </p>
        </div>

        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Accuracy & no guarantee</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          We make reasonable efforts to keep scheme information accurate and current. However:
        </p>
        <ul style={{ margin: '0 0 14px 20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <li style={{ fontSize: '15px', lineHeight: '1.65', color: '#23282B' }}>
            Scheme eligibility criteria, benefits, and application processes are set by the respective government departments and can change without notice
          </li>
          <li style={{ fontSize: '15px', lineHeight: '1.65', color: '#23282B' }}>
            We do not guarantee that you will be approved for any scheme you are matched with or apply to — final approval rests entirely with the relevant government authority
          </li>
          <li style={{ fontSize: '15px', lineHeight: '1.65', color: '#23282B' }}>
            You should verify scheme details on the official government source where possible before relying on them for major decisions
          </li>
        </ul>

        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Your responsibilities</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          When using YojanaSaathi, you agree to:
        </p>
        <ul style={{ margin: '0 0 14px 20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <li style={{ fontSize: '15px', lineHeight: '1.65', color: '#23282B' }}>Provide accurate and truthful information in your profile and applications</li>
          <li style={{ fontSize: '15px', lineHeight: '1.65', color: '#23282B' }}>Keep your account credentials confidential and secure</li>
          <li style={{ fontSize: '15px', lineHeight: '1.65', color: '#23282B' }}>Use the Service only for lawful purposes</li>
          <li style={{ fontSize: '15px', lineHeight: '1.65', color: '#23282B' }}>Not attempt to misuse, reverse-engineer, or interfere with the Service's operation</li>
        </ul>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          Submitting false information to obtain scheme benefits you are not eligible for may have legal consequences under applicable law, separate from your use of this Service.
        </p>

        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Scheme applications</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          Where YojanaSaathi allows you to submit an application directly through the app, we act as a facilitator that transmits your provided information and documents to the relevant scheme's processing system or department. We are not responsible for delays, rejections, or decisions made by the government department processing your application.
        </p>

        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Intellectual property</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          The YojanaSaathi name, logo, app design, and underlying software are the property of YojanaSaathi and may not be copied, modified, or redistributed without permission. Government scheme names and content remain the property of their respective departments.
        </p>

        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Limitation of liability</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          To the extent permitted by law, YojanaSaathi is not liable for any indirect, incidental, or consequential loss arising from your use of the Service, including loss arising from inaccurate scheme information, application delays, or decisions made by government authorities.
        </p>

        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Termination</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          We may suspend or terminate your access to the Service if you violate these Terms or misuse the platform. You may stop using the Service and request account deletion at any time.
        </p>

        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Governing law</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          These Terms are governed by the laws of India. Any disputes arising from these Terms or your use of the Service will be subject to the jurisdiction of the courts in India.
        </p>

        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Changes to these terms</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          We may update these Terms from time to time. Continued use of the Service after changes are posted constitutes acceptance of the revised Terms.
        </p>

        <h2 style={{ 
          fontFamily: "'Fraunces', serif",
          fontSize: '21px', 
          color: '#102844',
          margin: '38px 0 14px'
        }}>Contact us</h2>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#23282B', marginBottom: '14px' }}>
          For questions about these Terms, reach us at <a href="mailto:yojanasaathi@gmail.com" style={{ color: '#1B3A5C' }}>yojanasaathi@gmail.com</a> or via our <a href="#" onClick={(e) => { e.preventDefault(); go('contact'); }} style={{ color: '#1B3A5C' }}>contact page</a>.
        </p>
      </div>
    </div>
  );
}